import "@/App.css";
import EmployeeForm from "@/pages/EmployeeForm";

// Single page: every path shows the New Employee File form
function App() {
  return <EmployeeForm />;
}

export default App;
